import React, { useState } from "react";
import { Button } from "../../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from "../../../design/dialog";
import { useAttorney } from "../../../contexts/AttorneyContext";
import { Attorney } from "@visitproof/types";

interface Props {
  attorney: Attorney;
}

const DeactivateAttorneyButton: React.FC<Props> = ({ attorney }) => {
  const { updateAttorney } = useAttorney();
  const [isOpen, setIsOpen] = useState(false);
  const [isDeactivating, setIsDeactivating] = useState(false);

  const handleDeactivate = async () => {
    setIsDeactivating(true);
    try {
      await updateAttorney(attorney.id, { status: "inactive" });
      setIsOpen(false);
    } catch (error) {
      console.error("Error deactivating attorney:", error);
    } finally {
      setIsDeactivating(false);
    }
  };

  return (
    <>
      <Button type="button" outline onClick={() => setIsOpen(true)}>
        Deactivate
      </Button>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Deactivate Attorney</DialogTitle>
        <DialogDescription>
          Are you sure you want to deactivate {attorney.firstName}{" "}
          {attorney.lastName}? They will no longer appear in attorney lists when
          assigning to cases, but their existing case assignments will remain.
        </DialogDescription>
        <DialogBody />
        <DialogActions>
          <Button plain onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button
            color="red"
            disabled={isDeactivating}
            onClick={handleDeactivate}
          >
            {isDeactivating ? "Deactivating..." : "Deactivate"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeactivateAttorneyButton;
